import { render } from "./CovidWarningDialog.vue?vue&type=template&id=7f541ea4&scoped=true"
import script from "./CovidWarningDialog.vue?vue&type=script&lang=js"
export * from "./CovidWarningDialog.vue?vue&type=script&lang=js"

import "./CovidWarningDialog.vue?vue&type=style&index=0&id=7f541ea4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f541ea4"]])

export default __exports__